import { ListItem } from '@material-ui/core';
import { ListItemProps } from '@mui/material';
import { FeatureFlags } from 'src/types/feature-flag';
import { useFeatureFlag } from 'src/utils/hooks/featureFlag';

interface FeatureFlagListItemProps extends ListItemProps {
  featureFlag: keyof FeatureFlags;
}

export default function FeatureFlagListItem({
  featureFlag,
  children,
  ...props
}: FeatureFlagListItemProps) {
  const isActive = useFeatureFlag(featureFlag);
  if (!isActive) return null;
  return <ListItem {...props}>{children}</ListItem>;
}
